import React from 'react';
import { brandClasses } from '../../theme';

interface EmptyLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * EmptyLayout - Blank layout for special pages
 *
 * Use for:
 * - Full-screen canvas views
 * - Public pages (invite redemption)
 * - Error pages
 * - Other full-width content
 */
export const EmptyLayout: React.FC<EmptyLayoutProps> = ({ children, className }) => {
  return (
    <div className={`min-h-screen ${brandClasses.appShell} ${className || ''}`}>
      {children}
    </div>
  );
};
